module.exports = require("unicode-trie");